module.exports = __webpack_public_path__ + "static/media/gallery-icon.c1b83e54.png";